export default __webpack_public_path__ + "static/warning-messages-awareness-dont-d0eb1bfb2781d839f77291f4825f3f56.png";